export default __webpack_public_path__ + "static/media/provider-onboarding-shapes.e5eb3894.svg";